export default [
  {
    programNumber: '01',
    programName: '01. «Развитие здравоохранения Свердловской области до 2024 года»',
    subprograms: [
      {
        subprogramNumber: '2',
        subprogramName:
          '2. Совершенствование оказания специализированной, включая высокотехнологичную, медицинской помощи, скорой, в том числе скорой специализированной, медицинской помощи',
        events: [
          {
            eventNumber: '1',
            eventName: '1. Обеспечение жителей Свердловской области специализированной медицинской помощью',
            rows: [
              {
                sourceOfFinancing: 'средства Территориального фонда обязательного медицинского страхования',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 14516513,80\n2018: 18254150,30\n2019: 19727309,20\n2020: 21025649,40\n2021: 22282130,20\n2022: 21107617,10\n2023: 21888599,10\n2024: 22698477,20\n',
                indicators:
                  '1.1.1.1., 2.2.1.1., 2.2.1.2., 2.2.1.3., 2.2.1.4., 2.2.1.5., 2.2.1.8., 2.2.1.14., 2.2.1.15., 2.2.1.16., 2.2.2.4., 3.3.1.1., 3.3.1.2., 3.3.1.14., 6.6.1.7., 6.6.1.8., 6.6.1.9., 10.10.1.1., 13.13.1.6.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 5888729,30\n2018: 6432285,80\n2019: 6458538,30\n2020: 6096060,70\n2021: 6224248,00\n2022: 5072676,80\n2023: 5087546,20\n2024: 5102415,60\n',
                indicators:
                  '1.1.1.1., 2.2.1.1., 2.2.1.2., 2.2.1.3., 2.2.1.4., 2.2.1.5., 2.2.1.8., 2.2.1.14., 2.2.1.15., 2.2.1.16., 2.2.2.4., 3.3.1.1., 3.3.1.2., 3.3.1.14., 6.6.1.7., 6.6.1.8., 6.6.1.9., 10.10.1.1., 13.13.1.6.',
              },
            ],
          },
          {
            eventNumber: '4',
            eventName: '4. Обеспечение эндопротезами',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 33000,00\n2018: 33000,00\n2019: 22000,00\n2020: 22000,00\n2021: 22000,00\n2022: 33000,00\n2023: 33000,00\n2024: 33000,00\n',
                indicators: '10.10.1.1.',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    programNumber: '02',
    programName: '02. «Развитие системы образования в Свердловской области до 2024 года»',
    subprograms: [
      {
        subprogramNumber: '1',
        subprogramName: '1. Реализация проекта «Уральская инженерная школа»',
        events: [
          {
            eventNumber: '1',
            eventName:
              '1. Организация мероприятий по развитию материально-технической базы государственных образовательных организаций Свердловской области, участвующих в реализации проекта «Уральская инженерная школа»',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 61991,00\n2018: 25260,50\n2019: 5663,00\n2020: 50791,40\n2021: 35000,00\n2022: 35000,00\n2023: 35000,00\n2024: 35000,00\n2025: 0,00\n',
                indicators: '1.1.1.8., 1.1.1.9., 1.1.1.11., 1.1.2.1., 1.1.2.2., 1.1.2.5.',
              },
            ],
          },
          {
            eventNumber: '2',
            eventName:
              '2. Организация и проведение общеобластных мероприятий в сфере образования в рамках реализации проекта «Уральская инженерная школа»',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 20900,00\n2018: 20900,00\n2019: 49337,00\n2020: 48787,00\n2021: 48787,00\n2022: 15000,00\n2023: 15000,00\n2024: 15000,00\n2025: 16000,00\n',
                indicators: '1.1.1.4., 1.1.2.7., 1.1.2.8.',
              },
            ],
          },
          {
            eventNumber: '3',
            eventName:
              '3. Обеспечение условий реализации муниципальными образовательными организациями в Свердловской области образовательных программ естественно-научного цикла и профориентационной работы',
            rows: [
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 26000,00\n2018: 26000,00\n2019: 15000,00\n2020: 39000,00\n2021: 39000,00\n2022: 15000,00\n2023: 15000,00\n2024: 15000,00\n2025: 0,00\n',
                indicators: '1.1.1.1., 1.1.1.2., 1.1.2.3., 1.1.3.1., 2.2.1.11., 2.2.12.1.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 26000,00\n2018: 26000,00\n2019: 15000,00\n2020: 39000,00\n2021: 39000,00\n2022: 15000,00\n2023: 15000,00\n2024: 15000,00\n2025: 0,00\n',
                indicators: '1.1.1.1., 1.1.1.2., 1.1.2.3., 1.1.3.1., 2.2.1.11., 2.2.12.1.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 26000,00\n2018: 26000,00\n2019: 15000,00\n2020: 39000,00\n2021: 39000,00\n2022: 15000,00\n2023: 15000,00\n2024: 15000,00\n2025: 0,00\n',
                indicators: '1.1.1.1., 1.1.1.2., 1.1.2.3., 1.1.3.1., 2.2.1.11., 2.2.12.1.',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    programNumber: '03',
    programName: '03. «Социальная поддержка и социальное обслуживание населения Свердловской области до 2024 года»',
    subprograms: [
      {
        subprogramNumber: '4',
        subprogramName: '4. Счастливая семья',
        events: [
          {
            eventNumber: '2',
            eventName:
              '2. Обеспечение выплаты родителям (законным представителям) частичной компенсации расходов на оплату стоимости путевок в санаторные оздоровительные лагеря круглогодичного действия и загородные оздоровительные лагеря, расположенные на территории Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 13196,00\n2018: 13459,90\n2019: 15628,30\n2020: 17671,00\n2021: 18378,00\n2022: 13196,00\n2023: 13196,00\n2024: 13196,00\n',
                indicators: '3.1.1.1.',
              },
            ],
          },
          {
            eventNumber: '4',
            eventName:
              '4. Реализация Закона Свердловской области от 15 июля 2013 года № 78-ОЗ «Об образовании в Свердловской области» в части оплаты в размере 50 процентов стоимости проезда на железнодорожном транспорте общего пользования в пригородном сообщении для обучающихся общеобразовательных организаций, достигших возраста семи лет, а также обучающихся по очной форме обучения в профессиональных образовательных организациях и образовательных организациях высшего образования ',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2017: 77856,10\n2018: 86023,50\n2019: 96457,80\n2020: 93415,30\n2021: 97151,90\n2022: 73048,40\n2023: 73048,40\n2024: 73048,40\n',
                indicators: '3.1.1.1.',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    programNumber: '04',
    programName:
      '04. «Развитие жилищно-коммунального хозяйства и повышение энергетической эффективности в Свердловской области до 2024 года»',
    subprograms: [
      {
        subprogramNumber: '2',
        subprogramName: '2. Развитие топливно-энергетического комплекса Свердловской области',
        events: [
          {
            eventNumber: '1',
            eventName:
              '1. Предоставление субсидий на реализацию проектов капитального строительства муниципального значения по развитию газификации населённых пунктов городского типа, всего, из них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2014: 219950,30\n2015: 105589,90\n2016: 358878,40\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1., 2.1.1.2.',
              },
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2014: 219950,30\n2015: 105589,90\n2016: 358878,40\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1., 2.1.1.2.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2014: 59741,30\n2015: 71939,60\n2016: 24731,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1., 2.1.1.2.',
              },
            ],
          },
          {
            eventNumber: '1',
            eventName: '1. Предоставление субсидий на реализацию мероприятий по развитию газификации',
            rows: [
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Иные капитальные вложения',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 10000,00\n2022: 12000,00\n2023: 13400,00\n2024: 14800,00\n',
                indicators: '2.1.1.3.',
              },
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Иные капитальные вложения',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 100000,00\n2022: 110000,00\n2023: 121000,00\n2024: 133100,00\n',
                indicators: '2.1.1.3.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Иные капитальные вложения',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 100000,00\n2022: 110000,00\n2023: 121000,00\n2024: 133100,00\n',
                indicators: '2.1.1.3.',
              },
            ],
          },
          {
            eventNumber: '1',
            eventName:
              '1. Предоставление субсидий на реализацию проектов капитального строительства муниципального значения по развитию газификации, всего, из них',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 349700,00\n2018: 349700,00\n2019: 440000,00\n2020: 350000,00\n2021: 350000,00\n2022: 470000,00\n2023: 490000,00\n2024: 515000,00\n',
                indicators: '2.1.1.1.1., 2.1.1.2.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 28289,80\n2018: 30610,20\n2019: 39742,40\n2020: 35000,00\n2021: 35000,00\n2022: 52000,00\n2023: 55000,00\n2024: 57000,00\n',
                indicators: '2.1.1.1.1., 2.1.1.2.',
              },
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 349700,00\n2018: 349700,00\n2019: 440000,00\n2020: 350000,00\n2021: 350000,00\n2022: 470000,00\n2023: 490000,00\n2024: 515000,00\n',
                indicators: '2.1.1.1.1., 2.1.1.2.',
              },
            ],
          },
          {
            eventNumber: '2',
            eventName:
              '2. Разработка и ежегодная корректировка схемы и программы развития электроэнергетического комплекса Свердловской области на среднесрочную перспективу, всего, из них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Научно-исследовательские и опытно-конструкторские работы',
                budgets:
                  '2014: 17900,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.5., 2.2.2.6., 2.2.2.7.',
              },
            ],
          },
          {
            eventNumber: '3',
            eventName:
              '3. Корректировка схемы и программы развития электроэнергетического комплекса Свердловской области на среднесрочную перспективу, всего, из них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Научно-исследовательские и опытно-конструкторские работы',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.5., 2.2.2.6., 2.2.2.7.',
              },
            ],
          },
          {
            eventNumber: '4',
            eventName:
              '4. Разработка программы вовлечения местных топливных ресурсов в топливный баланс Свердловской области, всего, из них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Научно-исследовательские и опытно-конструкторские работы',
                budgets:
                  '2014: 3600,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.3.',
              },
            ],
          },
          {
            eventNumber: '5',
            eventName:
              '5. Организация корректировки Генеральной схемы газоснабжения и газификации Свердловской области, всего, из них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1.',
              },
            ],
          },
          {
            eventNumber: '6',
            eventName:
              '6. Проведение конкурсных отборов заявок муниципальных образований на предоставление субсидий из средств областного бюджета; подготовка и представление в Правительство Свердловской области проектов нормативных правовых актов; проведение согласования и заключение соглашений с администрациями муниципальных образований в Свердловской области на получение субсидий из средств областного бюджета; контроль за соблюдением порядка предоставления  субсидий из областного бюджета, подготовка в установленном порядке отчетной информации по действующим и проектируемым областным  программам',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1.',
              },
            ],
          },
          {
            eventNumber: '7',
            eventName:
              '7. Участие в подготовке и проведении научно-практических конференций, семинаров, конкурсов по тематике развития отрасли',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1., 2.2.1.1., 2.2.2.1., 2.2.2.2., 2.2.2.4., 2.2.2.5., 2.2.2.6., 2.2.2.7.',
              },
            ],
          },
          {
            eventNumber: '8',
            eventName:
              '8. Участие в организации выполнения мероприятий гражданской обороны в режиме повседневной деятельности, в режиме повышенной готовности и  в чрезвычайном режиме по предупреждению и ликвидации последствий чрезвычайных ситуаций, связанных со стихийными бедствиями, отказами систем жизнеобеспечения или авариями на  объектах повышенной опасности',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.4.',
              },
            ],
          },
          {
            eventNumber: '9',
            eventName: '9. Организация и проведение конкурсов профессионального мастерства среди работников отрасли',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.4.',
              },
            ],
          },
          {
            eventNumber: '10',
            eventName:
              '10. Работа с кадровым резервом отрасли, включая проведение специальных семинаров, Уральского молодежного энергетического форума, выдвижение перспективных работников отрасли на участие в президентской программе подготовки управленческих кадров',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1., 2.2.1.1., 2.2.2.1., 2.2.2.2., 2.2.2.4., 2.2.2.5., 2.2.2.6., 2.2.2.7.',
              },
            ],
          },
          {
            eventNumber: '11',
            eventName:
              '11. Участие в организации и проведении проверок  готовности региональных предприятий электроэнергетического комплекса к работе в отопительный зимний период',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.1.',
              },
            ],
          },
          {
            eventNumber: '12',
            eventName: '12. Оптимизация процедуры подключения к электрическим сетям',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.1.1., 2.2.1.2.',
              },
            ],
          },
          {
            eventNumber: '13',
            eventName: '13. Организация работы Штаба по безопасности энергоснабжения потребителей Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.4.',
              },
            ],
          },
          {
            eventNumber: '14',
            eventName:
              '14. Мониторинг хода категорирования объектов и наличия паспортов безопасности у субъектов топливно-энергетического комплекса на территории Свердловской  области',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.2.',
              },
            ],
          },
          {
            eventNumber: '15',
            eventName:
              '15. Оказание содействия в реализации инвестиционных проектов генерирующими компаниями на территории Свердловской области, всего из них:',
            rows: [
              {
                sourceOfFinancing: 'внебюджетные источники',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 20000000,00\n2016: 20000000,00\n2017: 5000000,00\n2018: 1000000,00\n2019: 1000000,00\n2020: 1000000,00\n2021: 1000000,00\n2022: 1000000,00\n2023: 1000000,00\n2024: 1000000,00\n',
                indicators: '2.2.2.4., 2.2.2.5., 2.2.2.6., 2.2.2.7., 5.1.2.3.',
              },
            ],
          },
          {
            eventNumber: '16',
            eventName:
              '16. Разработка региональной Программы газификации Свердловской области на среднесрочную перспективу',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1.',
              },
            ],
          },
          {
            eventNumber: '17',
            eventName: '17. Разработка паспорта газового хозяйства Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1.',
              },
            ],
          },
          {
            eventNumber: '18',
            eventName:
              '18. Участие в разработке и реализации мероприятий по профилактике терроризма на объектах топливно-энергетического комплекса Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.4.',
              },
            ],
          },
          {
            eventNumber: '19',
            eventName:
              '19. Участие в разработке и реализации Программы импортозамещения для предприятий топливно-энергетического комплекса',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.5., 2.2.2.6., 2.2.2.7.',
              },
            ],
          },
          {
            eventNumber: '20',
            eventName:
              '20. Работа в рамках межведомственной комиссии по созданию системы обеспечения вызова экстренных оперативных служб по единому номеру "112" на территории  Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.4.',
              },
            ],
          },
          {
            eventNumber: '21',
            eventName:
              '21. Участие в ресурсном обеспечении программы ИЖС для многодетных и малообеспеченных (льготных) категорий граждан на территории Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.1.1.',
              },
            ],
          },
          {
            eventNumber: '22',
            eventName:
              '22. Совершенствование нормативно-правовой базы, обеспечивающей создание условий для снижения административных барьеров в сфере газораспределения',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.1.1., 2.2.1.3.',
              },
            ],
          },
          {
            eventNumber: '23',
            eventName:
              '23. Работа по реализации "майских" указов Президента Российской Федераци о долгосрочной государственной экономической политике и по созданию высокопроизводительных рабочих мест',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '5.1.2.7., 5.1.2.8.',
              },
            ],
          },
          {
            eventNumber: '24',
            eventName: '24. Работа по повышению доходного потенциала Свердловской области ',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.1.1., 2.2.2.1.',
              },
            ],
          },
          {
            eventNumber: '25',
            eventName:
              '25. Формирование ежеквартальной отчетности о динамике задолженности бюджетных потребителей перед поставщиками топливно-энергетических ресурсов в Министерство энергетики Российской Федерации',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.1.',
              },
            ],
          },
          {
            eventNumber: '26',
            eventName:
              '26. Повышение эффективности топливообеспечения жилищно-коммунального комплекса за счет использования местных топливных ресурсов и возобновляемых источников энергии',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2.3., 2.2.2.8.',
              },
            ],
          },
          {
            eventNumber: '27',
            eventName:
              '27. Рассмотрение и согласование проектов инвестиционных программ территориальных сетевых организаций, расположенных на территории Свердловской области, которые подлежат утверждению Министерством энергетики РФ',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '5.1.2.3.',
              },
            ],
          },
          {
            eventNumber: '28',
            eventName:
              '28. Организация утверждения инвестиционных программ и изменений в инвестиционные программы субъектов электроэнергетики, отнесенных к числу субъектов, инвестиционные программы которых утверждаются Правительством Свердловской области и контролируется Министерством энергетики и жилищно-коммунального хозяйства Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '5.1.2.3.',
              },
            ],
          },
          {
            eventNumber: '29',
            eventName:
              '29. Осуществление контроля за реализацией инвестиционных программ субъектов электроэнергетики, отнесенных к числу субъектов, инвестиционные программы которых утверждаются Правительством Свердловской области и контролируются Министерством энергетики и жилищно-коммунального хозяйства Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'внебюджетные источники',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 3051906,30\n2018: 4416299,70\n2019: 3964959,80\n2020: 3567416,70\n2021: 3043327,22\n2022: 3195493,58\n2023: 3355268,26\n2024: 3523031,70\n',
                indicators: '5.1.2.3.',
              },
            ],
          },
          {
            eventNumber: '30',
            eventName:
              '30. Модернизация информационной системы "Региональный портал по технологическому присоединению к электрическим сетям, к сетям газораспределения, к системам теплоснабжения, к централизованным системам водоснабжения и водоотведения"',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 4000,00\n2019: 6000,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.1.1., 2.2.1.2.',
              },
            ],
          },
          {
            eventNumber: '31',
            eventName:
              '31. Разработка Генеральной схемы газоснабжения и газификации Свердловской области на период до 2028 года и перспективу до 2035 года\n',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2014: 0,00\n2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 20000,00\n2020: 40000,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1.1.1., 2.1.1.2.',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    programNumber: '14',
    programName: '14. «Развитие транспортного комплекса Свердловской области до 2024 года»',
    subprograms: [
      {
        subprogramNumber: '1',
        subprogramName: '1. «Развитие транспорта и транспортно-логистического комплекса Свердловской области»',
        events: [
          {
            eventNumber: '4',
            eventName:
              '4. Строительство и реконструкция улично-дорожной сети со строительством трамвайной линии в границах городского округа Верхняя Пышма и муниципального образования «город Екатеринбург»',
            rows: [
              {
                sourceOfFinancing: 'федеральный бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 1.2.5.4., 1.2.5.7.',
              },
              {
                sourceOfFinancing: 'внебюджетные источники',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 1.2.5.4., 1.2.5.7.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2018: 591870,00\n2019: 183116,00\n2020: 443115,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 1.2.5.4., 1.2.5.7.',
              },
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 1.2.5.4., 1.2.5.7.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2018: 294658,20\n2019: 460890,00\n2020: 399625,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 1.2.5.4., 1.2.5.7.',
              },
            ],
          },
          {
            eventNumber: '5',
            eventName:
              '5. Управление пассажирскими перевозками в период подготовки и проведения чемпионата мира по футболу в 2018 году',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Научно-исследовательские и опытно-конструкторские работы',
                budgets: '2018: 11100,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.3.7.',
              },
            ],
          },
          {
            eventNumber: '6',
            eventName:
              '6. Субсидии организациям железнодорожного транспорта на возмещение затрат, возникших в результате организации пригородных перевозок пассажиров и багажа в пригородном сообщении электропоездами серии «Ласточка» на территории Свердловской области в 2015–2017 годах, всего \nиз них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 1.2.5.5., 1.2.5.6., 4.3.12.7.',
              },
            ],
          },
          {
            eventNumber: '6',
            eventName:
              '6. Содействие повышению доступности перевозок населения железнодорожным транспортом в пригородном сообщении на территории Свердловской области, всего, из них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 1237766,60\n2019: 1430412,20\n2020: 1218157,90\n2021: 1217786,50\n2022: 1227800,00\n2023: 1227800,00\n2024: 1227800,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 1.2.5.5., 1.2.5.6., 4.3.12.7.',
              },
            ],
          },
          {
            eventNumber: '6',
            eventName:
              '6. Субсидии организациям железнодорожного транспорта на возмещение недополученных доходов, возникших в результате осуществления государственного регулирования тарифов на перевозки пассажиров и багажа в пригородном сообщении на территории Свердловской области, всего \nиз них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 1.2.5.5., 1.2.5.6., 4.3.12.7.',
              },
            ],
          },
          {
            eventNumber: '7',
            eventName:
              '7. Приобретение автобусов, работающих на газомоторном топливе, в рамках подготовки города Екатеринбурга к проведению в 2018 году чемпионата мира по футболу',
            rows: [
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 40462,50\n2019: 190692,00\n2020: 164201,90\n2021: 99181,00\n2022: 7227,60\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.1.1.1., 1.1.1.1.1., 1.1.1.1.2., 1.1.1.1.3., 1.1.1.2., 1.2.4.1., 1.2.4.2.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 364162,10\n2019: 190692,00\n2020: 164201,90\n2021: 99181,00\n2022: 7227,60\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.1.1.1., 1.1.1.1.1., 1.1.1.1.2., 1.1.1.1.3., 1.1.1.2., 1.2.4.1., 1.2.4.2.',
              },
            ],
          },
          {
            eventNumber: '8',
            eventName:
              '8. Организация перевозки пассажиров в городе Екатеринбурге по маршрутам спортивных соревнований в период проведения матчей чемпионата мира по футболу в 2018 году',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 44875,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.8., 1.2.5.9., 1.2.5.10.',
              },
            ],
          },
          {
            eventNumber: '9',
            eventName:
              '9. Управление пассажирскими перевозками в городе Екатеринбурге в период подготовки и проведения чемпионата мира по футболу в 2018 году',
            rows: [
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 4789,50\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.3.5., 1.2.3.6.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 91000,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.3.5., 1.2.3.6.',
              },
            ],
          },
          {
            eventNumber: '10',
            eventName: '10. Приобретение трамвайных вагонов',
            rows: [
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 71250,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.4.3.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 3750,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.4.3.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 71250,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.4.3.',
              },
            ],
          },
          {
            eventNumber: '11',
            eventName:
              '11. Приобретение коммунально-уборочной техники в рамках подготовки города Екатеринбурга к проведению матчей чемпионата мира по футболу в 2018 году',
            rows: [
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 14756,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.3.4.',
              },
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 280364,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.3.4.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 280364,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.3.4.',
              },
            ],
          },
          {
            eventNumber: '12',
            eventName:
              '12. Организация регулярных перевозок пассажиров и багажа автомобильным транспортом на территории Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 10150,00\n2019: 28981,40\n2020: 30000,00\n2021: 30000,00\n2022: 30000,00\n2023: 30000,00\n2024: 30000,00\n',
                indicators: '1.2.5.7.',
              },
            ],
          },
          {
            eventNumber: '13',
            eventName:
              '13. Обеспечение транспортной безопасности в рамках подготовки и проведения чемпионата мира по футболу в 2018 году на объектах транспортной инфраструктуры автомобильного транспорта, находящихся в собственности Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 36275,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.3.3.',
              },
            ],
          },
          {
            eventNumber: '24',
            eventName:
              '24. Разработка Концепции и операционного транспортного мастер-плана обеспечения мероприятий чемпионата мира ФИФА 2018 года в городе Екатеринбурге',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Научно-исследовательские и опытно-конструкторские работы',
                budgets: '2018: 1920,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.8., 1.2.5.9., 1.2.5.10.',
              },
            ],
          },
          {
            eventNumber: '25',
            eventName: '25. Организация планирования, расчета затрат и мониторинга пассажирских перевозок',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Научно-исследовательские и опытно-конструкторские работы',
                budgets: '2018: 10245,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.2.',
              },
            ],
          },
          {
            eventNumber: '26',
            eventName:
              '26. Организация перевозки пассажиров пассажирским автомобильным транспортом в пригородном сообщении на территории Свердловской области по маршрутам спортивных соревнований в период проведения матчей чемпионата мира по футболу FIFA 2018 года',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 440,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.2.',
              },
            ],
          },
          {
            eventNumber: '27',
            eventName:
              '27. Организация перевозки пассажиров железнодорожным транспортом в пригородном сообщении на территории Свердловской области по маршрутам спортивных соревнований в период проведения матчей чемпионата мира по футболу FIFA 2018 года, всего \nиз них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 151,10\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.5., 1.2.5.6.',
              },
            ],
          },
          {
            eventNumber: '28',
            eventName: '28. Организация транспортного обслуживания населения воздушным транспортом',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.2.1.',
              },
            ],
          },
          {
            eventNumber: '29',
            eventName: '29. Обеспечение транспортной безопасности на объектах транспортной инфраструктуры',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 0,00\n2019: 29300,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.3.8.',
              },
            ],
          },
        ],
      },
      {
        subprogramNumber: '3',
        subprogramName:
          '3. «Содействие развитию муниципального образования «город Екатеринбург» как центра Свердловской области» – «Столица»',
        events: [
          {
            eventNumber: '1',
            eventName:
              '1. Строительство и реконструкция автомобильных дорог общего пользования регионального значения, всего из них',
            rows: [
              {
                sourceOfFinancing: 'федеральный бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2018: 905000,00\n2019: 300000,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 3.2.5.1.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2018: 787300,90\n2019: 1676502,50\n2020: 2021221,90\n2021: 3548973,00\n2022: 3740105,10\n2023: 2243798,30\n2024: 3077111,00\n',
                indicators: '1.2.5.1., 1.2.5.3., 3.2.5.1.',
              },
            ],
          },
          {
            eventNumber: '2',
            eventName:
              '2. Строительство и реконструкция автомобильных дорог общего пользования местного значения в муниципальном образовании «город Екатеринбург», всего \nиз них:\n',
            rows: [
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2018: 26906,30\n2019: 658272,70\n2020: 496439,10\n2021: 364995,60\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2018: 511219,00\n2019: 658272,10\n2020: 496439,10\n2021: 364995,60\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1.',
              },
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets:
                  '2018: 511219,00\n2019: 658272,10\n2020: 496439,10\n2021: 364995,60\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1.',
              },
            ],
          },
          {
            eventNumber: '3',
            eventName:
              '3. Строительство, реконструкция и капитальный ремонт автомобильных дорог общего пользования местного значения в муниципальном образовании «город Екатеринбург» в рамках подготовки к чемпионату мира по футболу 2018 года, всего \nиз них:\n',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 189000,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1., 3.2.10.2.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 9947,50\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1., 3.2.10.2.',
              },
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 189000,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1., 3.2.10.2.',
              },
            ],
          },
          {
            eventNumber: '4',
            eventName:
              '4. Строительство (реконструкция) автомобильных дорог в рамках реализации проектов по развитию территорий, предусматривающих строительство жилья, на условиях софинансирования из федерального бюджета, всего из них:',
            rows: [
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1.',
              },
              {
                sourceOfFinancing: 'федеральный бюджет',
                directionOfExpenses: 'Бюджетные инвестиции в объекты капитального строительства',
                budgets: '2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1.',
              },
            ],
          },
          {
            eventNumber: '6',
            eventName:
              '6. Разработка проектной документации на строительство участков автомобильной дороги вокруг города Екатеринбурга, всего, из них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 10979,60\n2019: 13307,10\n2020: 34741,90\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.5.1.',
              },
            ],
          },
          {
            eventNumber: '7',
            eventName:
              '7. Подготовка территории строительства автомобильной дороги вокруг города Екатеринбурга, всего, из них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 270045,00\n2019: 376300,00\n2020: 60880,70\n2021: 98550,00\n2022: 154000,00\n2023: 649322,30\n2024: 169976,30\n',
                indicators: '3.2.5.1.',
              },
            ],
          },
          {
            eventNumber: '8',
            eventName:
              '8. Капитальный ремонт автомобильных дорог общего пользования местного значения в муниципальном образовании «город Екатеринбург», всего, из них:',
            rows: [
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 74922,00\n2019: 147612,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.2.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 3944,20\n2019: 7771,40\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.2.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 74922,00\n2019: 147612,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.2.',
              },
            ],
          },
          {
            eventNumber: '9',
            eventName:
              '9. Ремонт автомобильных дорог общего пользования местного значения города Екатеринбурга как административного центра Свердловской области',
            rows: [
              {
                sourceOfFinancing: 'субсидии местным бюджетам',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 700000,00\n2019: 500000,00\n2020: 500000,00\n2021: 500000,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.3.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 700000,00\n2019: 500000,00\n2020: 500000,00\n2021: 500000,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.3.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 36842,20\n2019: 26315,80\n2020: 26315,80\n2021: 26315,80\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.3.',
              },
            ],
          },
          {
            eventNumber: '10',
            eventName:
              '10. Реализация мероприятий приоритетного проекта «Безопасные и качественные дороги» в муниципальном образовании «город Екатеринбург»',
            rows: [
              {
                sourceOfFinancing: 'федеральный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 800000,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.3.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 42105,30\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.3.',
              },
            ],
          },
          {
            eventNumber: '11',
            eventName:
              '11. Реализация мероприятий национального проекта «Безопасные и качественные автомобильные дороги» (автомобильные дороги общего пользования местного значения в муниципальном образовании «город Екатеринбург»)',
            rows: [
              {
                sourceOfFinancing: 'федеральный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 0,00\n2019: 1000000,00\n2020: 1000000,00\n2021: 1000000,00\n2022: 1000000,00\n2023: 1000000,00\n2024: 1000000,00\n',
                indicators: '3.2.10.3.',
              },
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2018: 0,00\n2019: 52632,00\n2020: 52632,00\n2021: 52632,00\n2022: 52632,00\n2023: 52632,00\n2024: 52632,00\n',
                indicators: '3.2.10.3.',
              },
            ],
          },
          {
            eventNumber: '12',
            eventName:
              '12. Реализация мероприятий в области дорожной деятельности, связанных с подготовкой и проведением праздничных мероприятий, посвященных 300-летию основания города Екатеринбурга, всего из них:\n',
            rows: [
              {
                sourceOfFinancing: 'местный бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 0,00\n2019: 12689,50\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1.',
              },
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets: '2018: 0,00\n2019: 241100,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.10.1.',
              },
            ],
          },
          {
            eventNumber: '13',
            eventName:
              '13. Реализация мероприятий национального проекта «Безопасные и качественные автомобильные дороги» (строительство транспортной развязки в разных уровнях на пересечении автомобильной дороги вокруг г. Екатеринбурга на участке автодорога Пермь – Екатеринбург – автодорога Подъезд к г. Екатеринбургу от автодороги «Урал», I пусковой комплекс, автодорога Пермь – Екатеринбург – автодорога Подъезд к п. Медному и автомобильной дороги «Подъезд к оз. Чусовское от км 354+630 а/д «г. Пермь – г. Екатеринбург» на территории муниципального образования «город Екатеринбург» в Свердловской области), всего\nиз них:',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Капитальные вложения',
                budgets:
                  '2018: 0,00\n2019: 100000,00\n2020: 110648,80\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.5.1.',
              },
            ],
          },
          {
            eventNumber: '14',
            eventName:
              '14. Реализация мероприятий национального проекта «Безопасные и качественные автомобильные дороги» (строительство автомобильной дороги вокруг г. Екатеринбурга на участке автодорога Пермь – Екатеринбург – автодорога Подъезд к г. Екатеринбургу от автодороги «Урал», III пусковой комплекс, автодорога Екатеринбург – Полевской – автодорога Подъезд к г. Екатеринбургу от автодороги «Урал» в Свердловской области)',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Капитальные вложения',
                budgets: '2018: 0,00\n2019: 18492,80\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.5.1.',
              },
              {
                sourceOfFinancing: 'федеральный бюджет',
                directionOfExpenses: 'Капитальные вложения',
                budgets: '2018: 0,00\n2019: 570000,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.5.1.',
              },
            ],
          },
          {
            eventNumber: '15',
            eventName:
              '15. Реализация мероприятий национального проекта «Безопасные и качественные автомобильные дороги» (реконструкция автомобильной дороги вокруг г. Екатеринбурга на участке Семь Ключей – Большой Исток на территории муниципального образования «город Екатеринбург» в Свердловской области)',
            rows: [
              {
                sourceOfFinancing: 'федеральный бюджет',
                directionOfExpenses: 'Капитальные вложения',
                budgets: '2018: 0,00\n2019: 430000,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.2.5.1.',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    programNumber: '20',
    programName:
      '20. «Осуществление регионального государственного жилищного и строительного надзора на территории Свердловской области до 2024 года»',
    subprograms: [
      {
        subprogramNumber: '0',
        subprogramName: 'Отсутствуют',
        events: [
          {
            eventNumber: '1',
            eventName: '1. Обеспечение деятельности государственных органов (центральный аппарат),\nв том числе:\n',
            rows: [
              {
                sourceOfFinancing: 'областной бюджет',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 224210,90\n2016: 223201,00\n2017: 235604,30\n2018: 263566,80\n2019: 308836,20\n2020: 321128,90\n2021: 332953,10\n2022: 244560,30\n2023: 244560,30\n2024: 244560,30\n',
                indicators:
                  '1.1.1., 1.1.2., 1.1.3., 1.1.4., 1.1.5., 1.1.6., 1.2.1., 1.2.2., 1.3.1., 1.3.2., 1.3.3., 1.3.4., 1.3.5., 1.4.1., 2.1.1., 2.1.2., 2.1.3., 2.1.4., 2.2.1., 2.2.2., 2.2.3., 2.2.4.',
              },
            ],
          },
          {
            eventNumber: '2',
            eventName:
              '2. Проведение внеплановых проверок соблюдения обязательных требований жилищного законодательства, законодательства об энергосбережении, лицензионных требований',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.1.1., 1.1.2., 1.1.3., 1.1.6., 1.2.1.',
              },
            ],
          },
          {
            eventNumber: '3',
            eventName:
              '3. Анализ поступающей информации об исполнении предписаний, проведение внеплановых проверок исполнения предписаний об устранении выявленных нарушений требований жилищного законодательства, законодательства об энергосбережении, законодательства о раскрытии информации в сфере управления многоквартирными домами, лицензионных требований',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.1.1., 1.1.6.',
              },
            ],
          },
          {
            eventNumber: '5',
            eventName:
              '5. Проведение внеплановых проверок в отношении соискателей лицензий на осуществление предпринимательской деятельности по управлению многоквартирными домами на территории Свердловской области на предмет соблюдения ими лицензионных требований\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.1.',
              },
            ],
          },
          {
            eventNumber: '6',
            eventName:
              '6. Подготовка и направление в лицензионную комиссию Свердловской области мотивированных предложений о предоставлении / об отказе в предоставлении лицензии от общего количества поступивших заявлений на получение лицензии',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.2.2.',
              },
            ],
          },
          {
            eventNumber: '7',
            eventName:
              '7. Проведение внеплановых проверок Регионального фонда содействия капитальному ремонту общего имущества в многоквартирных домах Свердловской области (далее - региональный оператор) на основании обращений, ранее выданных предписаний\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.3.1., 1.3.2.',
              },
            ],
          },
          {
            eventNumber: '8',
            eventName:
              '8. Формирование сведений об осмотрах и фактическом техническом состоянии многоквартирных домов, расположенных на территории Свердловской области\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.3.3., 1.3.4.',
              },
            ],
          },
          {
            eventNumber: '9',
            eventName:
              '9. Формирование и направление в Министерство строительства и жилищно-коммунального хозяйства Российской Федерации сведений о многоквартирных домах, собственники помещений в которых формируют фонды капитального ремонта на счете, счетах регионального оператора, о поступлении взносов на капитальный ремонт от собственников помещений в указанных многоквартирных домах\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.3.5.',
              },
            ],
          },
          {
            eventNumber: '10',
            eventName:
              '10. Проведение внеплановых проверок строящихся, реконструируемых объектов капитального строительства\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1., 2.1.2., 2.1.5.',
              },
            ],
          },
          {
            eventNumber: '11',
            eventName:
              '11. Контроль исполнения предписаний об устранении выявленных нарушений требований законодательства о градостроительной деятельности, анализ поступающей информации об исполнении предписаний\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.1., 2.1.5.',
              },
            ],
          },
          {
            eventNumber: '12',
            eventName:
              '12. Проведение проверок объектов капитального строительства, реконструкции в соответствии с программами проверок\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.3., 2.1.5.',
              },
            ],
          },
          {
            eventNumber: '13',
            eventName:
              '13. Выдача заключения о соответствии построенного, реконструированного объекта капитального строительства требованиям технических регламентов (норм и правил), иных нормативных правовых актов и проектной документации, в том числе требованиям в отношении энергетической эффективности и требованиям в отношении оснащенности объекта капитального строительства приборами учета используемых энергетических ресурсов, решений об отказе в выдаче заключений\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.4.',
              },
            ],
          },
          {
            eventNumber: '14',
            eventName:
              '14. Проведение внеплановых проверок деятельности застройщиков, связанной с привлечением денежных средств участников долевого строительства для строительства (создания) многоквартирных домов и (или) иных объектов недвижимости на территории Свердловской области\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.2.2., 2.2.4.',
              },
            ],
          },
          {
            eventNumber: '15',
            eventName:
              '15. Проведение внеплановых проверок исполнения предписаний об устранении выявленных нарушений требований законодательства об участии в долевом строительстве многоквартирных домов и (или) иных объектов недвижимости\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '2.1.5., 2.2.1.',
              },
            ],
          },
          {
            eventNumber: '16',
            eventName:
              '16. Возбуждение и рассмотрение дел об административных правонарушениях, предусмотренных Кодексом Российской Федерации об административных правонарушениях, направление дел на рассмотрение мировым судьям\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.1.1., 1.1.2., 1.1.3., 1.1.4., 1.1.5., 1.3.2., 2.1.1., 2.1.2., 2.1.3., 2.2.1., 2.2.3.',
              },
            ],
          },
          {
            eventNumber: '17',
            eventName:
              '17. Проведение плановых проверок юридических лиц, индивидуальных предпринимателей, органов местного самоуправления и их должностных лиц в соответствии с планами проверок, согласованных с органами прокуратуры, оформление исполнительных документов по результатам проверок\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.1.5., 1.1.6., 2.2.3., 2.2.4.',
              },
            ],
          },
          {
            eventNumber: '18',
            eventName:
              '18. Рассмотрение обращений граждан и юридических лиц, поручений Правительства Российской Федерации, поручений Президента Российской Федерации, требований прокурора\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.1.2., 1.3.2., 2.1.2., 2.2.2.',
              },
            ],
          },
          {
            eventNumber: '19',
            eventName:
              '19. Проведение информационно-разъяснительной работы, направленной на профилактику и предупреждение правонарушений в градостроительной и жилищно-коммунальной сфере\n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.1.2., 1.3.2., 2.1.2., 2.2.2.',
              },
            ],
          },
          {
            eventNumber: '20',
            eventName:
              '20. Проведение обучающих семинаров по управленческим округам Свердловской области с участием граждан, представителей администраций муниципальных образований, расположенных на территории Свердловской области, организаций, осуществляющих управление многоквартирными домами, ресурсоснабжающих организаций и общественных обсуждений в сфере жилищно-коммунального \n',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '1.4.1.',
              },
            ],
          },
          {
            eventNumber: '21',
            eventName: '21. Мониторинг кредиторской задолженности по обязательствам Департамента',
            rows: [
              {
                sourceOfFinancing: 'не указан',
                directionOfExpenses: 'Прочие нужды',
                budgets:
                  '2015: 0,00\n2016: 0,00\n2017: 0,00\n2018: 0,00\n2019: 0,00\n2020: 0,00\n2021: 0,00\n2022: 0,00\n2023: 0,00\n2024: 0,00\n',
                indicators: '3.1.1.',
              },
            ],
          },
        ],
      },
    ],
  },
];
